//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CreatorsCampaignsMember } from '@apis/creators-campaigns/CreatorsCampaignsApiModel';
import { SliceNames } from '@redux/SliceNames';

const initialState: { selectedCreators: Partial<CreatorsCampaignsMember>[] } = {
  selectedCreators: [],
};

const { actions, reducer: CreatorsCampaignMembers } = createSlice({
  name: SliceNames.creatorsCampaignMembers,
  initialState,
  reducers: {
    toggleCreatorSelection(
      state,
      {
        payload: campaignMember,
      }: PayloadAction<Partial<CreatorsCampaignsMember>>,
    ) {
      if (
        campaignMember.creator?.id &&
        campaignMember.creator.username &&
        campaignMember.creator.network
      ) {
        const { id, network } = campaignMember.creator;
        const isSelected = state.selectedCreators.some(
          (user) => user.creator?.id === id && user.creator.network === network,
        );
        if (isSelected) {
          // Remove user if already selected
          state.selectedCreators = state.selectedCreators.filter(
            (user) =>
              !(user.creator?.id === id && user.creator.network === network),
          );
        } else {
          // Add user to the selected list
          state.selectedCreators.push(campaignMember);
        }
      }
    },
    clearCreatorsSelection(state) {
      state.selectedCreators = [];
    },
    removeCreatorsFromSelection(
      state,
      {
        payload: campaignMembers,
      }: PayloadAction<Partial<CreatorsCampaignsMember>[]>,
    ) {
      state.selectedCreators = state.selectedCreators.filter((user) => {
        return !campaignMembers.some((member) => {
          return (
            user.creator?.id === member.creator?.id &&
            user.creator?.network === member.creator?.network
          );
        });
      });
    },
    addCreatorsToSelection(
      state,
      {
        payload: campaignMembers,
      }: PayloadAction<Partial<CreatorsCampaignsMember>[]>,
    ) {
      state.selectedCreators = [
        ...state.selectedCreators,
        ...campaignMembers.filter((newMember) =>
          !state.selectedCreators.some(
            (existingMember) =>
              existingMember.creator?.id === newMember.creator?.id &&
              existingMember.creator?.network === newMember.creator?.network
          )
        ),
      ];
    }
  },
});

export const {
  toggleCreatorSelection,
  clearCreatorsSelection,
  removeCreatorsFromSelection,
  addCreatorsToSelection,
} = actions;

export { CreatorsCampaignMembers };
